import React, { useEffect, useState, useRef } from "react";
import { Routes, Route, useNavigate, useLocation, matchPath } from "react-router-dom";
import SharedFormPage from "./pages/SharedFormPage.jsx";
import Header from "./components/Header.jsx";
import Sidebar from "./components/Sidebar.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import EditDashboard from "./pages/EditDashboard.jsx";
import Modeles from "./pages/Modeles.jsx";
import Accueil from "./pages/Accueil.jsx";
import Login from "./pages/Login.jsx";
import { auth, storage } from "./firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import UploadModele from "./pages/UploadModele.jsx";
import UseModele from "./pages/UseModele.jsx";
import RelationPage from "./pages/RelationPage.jsx";
import EditRelations from "./pages/EditRelations.jsx";
import EditDossiers from "./pages/EditDossiers.jsx";
import DossierPage from "./pages/DossierPage.jsx";
import useSync from "./hooks/useSync";
import MultiRelationFilter from "./components/MultiRelationFilter.jsx";
import {
  ensureAppSettings,
  loadAppSettingsHybrid,
  deleteModele,
  incrementMarketplaceDownloadCount,
  recordMarketplaceImport,
} from "./services/data";
import PlaceholdersConfig from "./pages/PlaceholdersConfig.jsx";
import GestionEquipes from "./pages/GestionEquipes.jsx";
import MarketplacePublish from "./pages/MarketplacePublish.jsx";
import MarketplaceManage from "./pages/MarketplaceManage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import SettingsPage from "./pages/SettingsPage.jsx";
import Marketplace from "./pages/Marketplace.jsx";
import OwnerApp from "./pages/owner/OwnerApp.jsx";
import MarketplaceTemplateDetail from "./pages/MarketplaceTemplateDetail.jsx";
import { ref as sRef, getDownloadURL, getBytes } from "firebase/storage";
import "./App.css";

function AppShell() {
  const navigate = useNavigate();
  const location = useLocation();
  const [route, setRoute] = useState("accueil");
  const [selectedClient, setSelectedClient] = useState(null);
  const [user, setUser] = useState(null);
  

  const [selectedModele, setSelectedModele] = useState(null);
  const [editingModele, setEditingModele] = useState(null);
  const [selectedDossier, setSelectedDossier] = useState(null);
  const [editingDraft, setEditingDraft] = useState(null);
  const [selectedMarketplaceItem, setSelectedMarketplaceItem] = useState(null);
  const [selectedRecord, setSelectedRecord] = useState(null); // [fire] nouvel état pour l'édition de documents
  const [previousRoute, setPreviousRoute] = useState(null);
  const [multiQueue, setMultiQueue] = useState([]);
  const [multiIndex, setMultiIndex] = useState(0);
  const [relTypeKeys, setRelTypeKeys] = useState([]);
  const [dosTypeKeys, setDosTypeKeys] = useState([]);
  const ensuredOnceRef = useRef(false);
  // [down] AJOUTE-LES
  const [sidebarOpen, setSidebarOpen] = useState(true); // true = ouverte
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 992 : false
  );
  const isUseModele = route === "useModele";
  // -> Handler partagé: édition d'un document généré (utilisé par Dashboard & DossierPage)
  const onEditRecord = (rec, meta) => {
    console.log("[Parent] Edit record", { rec, meta });
    setPreviousRoute(route);
    setSelectedModele(null);

    if (meta?.sourceKind === "relation") {
      // [puzzle] même comportement "comme dans la page relation"
      // on peut stocker l'item si tu veux le réutiliser dedans
      setSelectedClient(rec); // optionnel: dispo pour RelationPage si tu l'exploites
      setSelectedRecord(null);
      // route dynamique vers le type de relation concerné
      setRoute(meta?.typeKey || "editRelations");
      return;
    }

    // Par défaut: édition d'un enregistrement de Dossier dans UseModele
    setSelectedRecord(rec);
    setRoute("useModele");
  };

  const onImportMarketplaceTemplate = async (item) => {
    if (!user?.uid) {
      alert(
        "Connecte-toi ou crée un compte pour importer ce modèle dans ton espace."
      );
      return;
    }
    const parseConfigSnapshot = (raw) => {
      if (!raw) return null;
      if (typeof raw === "object") return raw;
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (_) {
          return null;
        }
      }
      return null;
    };
    const buildFromFieldsMeta = (fieldsMeta) => ({
      fields: fieldsMeta || {},
      sections: [],
      maps: {},
    });
    if (!item) {
      alert("Template indisponible.");
      return;
    }
    if (!item?.release?.docxPath) {
      alert("Ce template n'a pas encore de fichier disponible.");
      return;
    }
    if (item.id) {
      try {
        await incrementMarketplaceDownloadCount(item.id);
      } catch (err) {
        console.warn("[marketplace] increment imports failed:", err);
      }
      try {
        await recordMarketplaceImport(user.uid, item.id);
      } catch (err) {
        console.warn("[marketplace] record import failed:", err);
      }
    }

    const release = item.release || {};
    const releaseUrls = item.releaseUrls || {};

    const resolveDownloadURL = async (directUrl, storagePath, label) => {
      if (directUrl) return directUrl;
      if (!storagePath) return "";
      try {
        return await getDownloadURL(sRef(storage, storagePath));
      } catch (err) {
        console.warn(`[marketplace] ${label} download failed:`, err);
        return "";
      }
    };

    const fileURL = await resolveDownloadURL(
      releaseUrls.docxUrl,
      release.docxPath,
      "docx"
    );
    if (!fileURL) {
      alert("Impossible de récupérer le fichier .docx de ce modèle.");
      return;
    }

    const configURL = await resolveDownloadURL(
      releaseUrls.configUrl,
      release.configPath,
      "config"
    );

    let configInline =
      parseConfigSnapshot(release.configSnapshot) ||
      parseConfigSnapshot(item.configSnapshot);
    const configStoragePath = release.configPath || item.configPath || "";
    if (!configInline && configStoragePath) {
      try {
        const bytes = await getBytes(sRef(storage, configStoragePath));
        const decoder = new TextDecoder();
        const txt = decoder.decode(bytes);
        configInline = parseConfigSnapshot(txt);
      } catch (err) {
        console.warn(
          "[marketplace] Impossible de charger la configuration via Storage:",
          err
        );
      }
    }
    if (!configInline && configURL && typeof fetch === "function") {
      try {
        const resp = await fetch(configURL);
        if (resp.ok) {
          configInline = parseConfigSnapshot(await resp.json());
        }
      } catch (err) {
        console.warn(
          "[marketplace] Impossible de charger la configuration distante:",
          err
        );
      }
    }
    if (
      !configInline &&
      (item.fields_meta || item.fieldsMeta) &&
      typeof (item.fields_meta || item.fieldsMeta) === "object"
    ) {
      configInline = buildFromFieldsMeta(item.fields_meta || item.fieldsMeta);
    }

    const importedModele = {
      id: null,
      nom: item.title || "Modèle marketplace",
      description:
        item.description ||
        item.subtitle ||
        "Modèle importé depuis le marketplace.",
      dossier: "",
      type: item.category || "Contrat",
      source: "Marketplace",
      icon: "fas fa-file-contract",
      fileURL,
      storagePath: release.docxPath || "",
      configURL,
      configPath: configStoragePath || "",
      configInline,
      fields_meta: item.fields_meta || item.fieldsMeta || {},
      docxMeta: item.docxMeta || item.docx_meta || null,
      docx_meta: item.docxMeta || item.docx_meta || null,
      size: item.docxSize || item.size || 0,
      ext: "docx",
      utilise: 0,
      __fromMarketplace: true,
    };

    setEditingModele(importedModele);
    setPreviousRoute("marketplaceDetail");
    setRoute("uploadModele");
  };

  // Détection si on est dans l'app
  const isApp = React.useMemo(() => {
    const staticRoutes = [
      "dashboard",
      "models",      
      "uploadModele",
      "useModele",
      "editRelations",
      "editDossiers",
      "editDashboard",
      "multiRelationFilter",
      "placeholdersConfig",
      "teams",
      "marketplace",         // ✅ nouvelle route publique Marketplace
      "marketplaceDetail",   // ✅ page détail template marketplace
      "marketplacePublish", // ✅ nouvelle route interne
      "marketplaceManage",
      "profil", // ✅ nouvelle route interne (Profil)
      "settings", // ✅ nouvelle route interne (Paramètres)
      "owner",
    ];
    return (
      staticRoutes.includes(route) ||
      relTypeKeys.includes(route) ||
      dosTypeKeys.includes(route)
    );
  }, [route, relTypeKeys, dosTypeKeys]);

  console.log(
    "[marker] Route actuelle:",
    route,
    "isMobile:",
    isMobile,
    "sidebarOpen:",
    sidebarOpen
  );

  // Surveille la session Firebase
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      console.log("[auth] onAuthStateChanged ->", u ? u.uid : null);
      setUser(u || null);
      // [warning] ne casse pas les routes dynamiques (relations/dossiers) pendant que ça se synchronise
      if (u && !isApp) {
        // On ne redirige que si on est encore sur une vraie page "publique"
        if (route === "accueil" || route === "login") setRoute("dashboard");
      }
      if (!u && isApp) {
        setRoute("login");
      }
    });
    return () => unsub();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, isApp]);
  // [green] Lance la synchronisation automatique local <-> Firestore
  useSync(user);
  useEffect(() => {
    if (user?.uid) console.log("[ok] Sync actif pour", user.uid);
    else console.warn("[stop] Sync inactif (aucun utilisateur connecté)");
  }, [user]);
  useEffect(() => {
    if (!user?.uid) {
      setRelTypeKeys([]);
      setDosTypeKeys([]);
      return;
    }
    const unsub = loadAppSettingsHybrid(user.uid, async (app) => {
      if (!app && !ensuredOnceRef.current) {
        ensuredOnceRef.current = true;
        try {
          app = await ensureAppSettings(user.uid);
        } catch (e) {
          console.warn("ensureAppSettings:", e?.message || e);
        }
      }
      setRelTypeKeys((app?.relations?.types || []).map((t) => t.key));
      setDosTypeKeys((app?.dossiers?.types || []).map((t) => t.key));
    });
    return () => {
      try {
        unsub && unsub();
      } catch {}
    };
  }, [user?.uid]);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  // Landing / Login si pas connecté


  if (!user && (route === "accueil" || route === "login")) {
    return route === "accueil" ? (
      <>
        <Header user={null} onGoLogin={() => setRoute("login")} />
        <main className="main-content" style={{ padding: 0 }}>
          <Accueil onGoLogin={() => setRoute("login")} />
        </main>
      </>
    ) : (
      <>
        <Header user={null} onGoLogin={() => setRoute("login")} />
        <main className="main-content">
          <Login
            onSuccess={() => setRoute("dashboard")}
            onBack={() => setRoute("accueil")}
          />
        </main>
      </>
    );
  }

  // Application (connecté)
  return (
    <div>
      {!isUseModele && (
        <Header
        user={user}
        onGoLogin={() => setRoute("login")}
        onGoProfile={() => {
          setPreviousRoute(route);
          setRoute("profil");
        }}
        onGoSettings={() => {
          setPreviousRoute(route);
          setRoute("settings");
        }}
        onGoMarketplace={() => {
          navigate("/app/marketplace");
        }}
      />
      )}
      <div
        className={`main-layout ${isMobile ? "is-mobile" : "is-desktop"} ${
          !isMobile && !sidebarOpen ? "sidebar-closed" : ""
        }`}
      >
        {!isUseModele && (
          <Sidebar
          user={user}
          currentPage={route}
          open={isMobile ? sidebarOpen : true} // [ok] toujours ouvert sur desktop
          isMobile={isMobile}
          onNavigate={(r) => {
            console.log(
              "[search] App: onNavigate called with",
              r,
              "current route:",
              route,
              "isMobile:",
              isMobile
            );
            
            // [compat] Si on est sur /app/marketplace et qu'on navigue vers une page non-marketplace,
            // on quitte d'abord l'URL marketplace pour permettre le rendu state-based
            const marketplaceRoutes = ["marketplace", "marketplaceDetail", "marketplacePublish", "marketplaceManage"];
            if (
              location.pathname.startsWith("/app/marketplace") &&
              !marketplaceRoutes.includes(r)
            ) {
              console.log("[compat] Exiting marketplace URL before state-based navigation");
              navigate("/", { replace: true });
              // Petit délai pour laisser le navigate() se terminer avant setRoute
              setTimeout(() => {
                if (
                  r === "editDossiers" ||
                  r === "editRelations" ||
                  r === "useModele" ||
                  r === "editDashboard" ||
                  r === "placeholdersConfig"
                ) {
                  setPreviousRoute(route);
                }
                setRoute(r);
                if (isMobile) {
                  console.log("[search] App: Closing sidebar on mobile");
                  setSidebarOpen(false);
                }
              }, 50);
              return;
            }
            
            if (
              r === "editDossiers" ||
              r === "editRelations" ||
              r === "useModele" ||
              r === "editDashboard" ||
              r === "placeholdersConfig"
            ) {
              setPreviousRoute(route);
            }
            setRoute(r);
            if (isMobile) {
              console.log("[search] App: Closing sidebar on mobile");
              setSidebarOpen(false);
            } // <- referme le tiroir sur mobile
          }}
        />
        )}
        {!isUseModele && (
          <div
            className={`content-overlay ${isMobile && sidebarOpen ? "show" : ""}`}
            onClick={() => setSidebarOpen(false)}
          />
        )}
        <main className="main-content">
          {/* React Router routes for Marketplace (URL-based) */}
          <Routes>
            <Route
              path="/app/marketplace"
              element={
                <Marketplace
                  user={user}
                  onBack={() => navigate(-1)}
                  onPublish={() => {
                    setRoute("marketplacePublish");
                  }}
                />
              }
            />
            <Route
              path="/app/marketplace/:itemId"
              element={
                <MarketplaceTemplateDetail
                  user={user}
                  onImport={onImportMarketplaceTemplate}
                />
              }
            />
          </Routes>

          {/* State-based routing (existing pages) */}
          {!location.pathname.startsWith("/app/marketplace") && (
            <>
              {route === "dashboard" && (
                <Dashboard
                  user={user}
                  onGoUpload={() => setRoute("uploadModele")}
                  onEditRecord={onEditRecord}
                  onGoEdit={() => setRoute("editDashboard")} // <- pour le bouton Configurer
                  setRoute={setRoute} // <- pour la navigation depuis les widgets
                />
              )}
              {route === "marketplace" && (
                <Marketplace
                  user={user}
                  onBack={() => setRoute(previousRoute || "dashboard")}
                  onPublish={() => {
                    setPreviousRoute("marketplace");
                    setRoute("marketplacePublish");
                  }}
                  onPreview={(item) => {
                    if (!item) return;
                    setSelectedMarketplaceItem(item);
                    setPreviousRoute("marketplace");
                    setRoute("marketplaceDetail");
                  }}
                />
              )}

              {route === "marketplaceDetail" && (
                <MarketplaceTemplateDetail
                  user={user}
                  item={selectedMarketplaceItem}
                  onBack={() => {
                    // Retour simple vers la liste publique
                    setRoute("marketplace");
                  }}
                  onImport={onImportMarketplaceTemplate}
                />
              )}
          {route === "profil" && (
            <ProfilePage
              user={user}
              onBack={() => setRoute(previousRoute || "dashboard")}
            />
          )}
          {route === "settings" && (
            <SettingsPage
              user={user}
              onBack={() => setRoute(previousRoute || "dashboard")}
            />
          )}
          {route === "owner" &&
            (user ? (
              (() => {
                console.log("[nav] Enter route: owner, user.uid =", user?.uid || null);
                return <OwnerApp user={user} />;
              })()
            ) : (
              <Login
                onSuccess={() => setRoute("owner")}
                onBack={() => setRoute("accueil")}
              />
            ))}
          {route === "teams" && <GestionEquipes user={user} />}
          {route === "editDashboard" && ( // [ok]
            <EditDashboard
              user={user}
              onBack={() => setRoute(previousRoute || "dashboard")} // <- branche le bouton "Retour"
            />
          )}
          {route === "models" && (
            <Modeles
              user={user}
              onGoUpload={(modele) => {
                if (modele) {
                  setEditingModele(modele); // [fire] édition d'un modèle
                } else {
                  setEditingModele(null);
                }
                setRoute("uploadModele");
              }}
              onConfigure={(modele) => {
                setEditingModele(modele);
                setPreviousRoute("models");
                setRoute("placeholdersConfig");
              }}
              onUse={(m) => {
                setPreviousRoute(route);
                setSelectedModele(m);
                setSelectedRecord(null);
                setRoute("useModele");
              }}
              // ✅ Nouveau: clic "Ajouter au marketplace"
              onAddToMarketplace={(modele) => {
                setEditingModele(modele);
                setPreviousRoute("models");
                setRoute("marketplacePublish");
              }}              
            />
          )}        
          {route === "uploadModele" && (
            <UploadModele
              user={user}
              onBack={() => {
                setEditingModele(null);
                setRoute("models");
              }}
              onTryUse={(modeleTemp) => {
                setPreviousRoute(route);
                setSelectedModele(modeleTemp);
                setSelectedRecord(null);
                setRoute("useModele");
              }}
              editingModele={editingModele}
              onOpenManualConfig={(payload) => {
                const nextModele =
                  payload && payload.modele ? payload.modele : payload;
                setEditingModele((prev) => ({
                  ...(prev || {}),
                  ...(nextModele || {}),
                })); // [ok] merge, ne perd pas docxMeta
                setPreviousRoute("uploadModele");
                setRoute("placeholdersConfig");
              }}
            />
          )}
          {/* [fire] Edition ou utilisation d'un document généré */}
          {route === "useModele" && (
            <UseModele
              user={user}
              modele={selectedModele} // peut être null
              recordToEdit={selectedRecord} // requis en édition
              prefillData={multiQueue[multiIndex] || {}}
              onBack={() => {
                setSelectedRecord(null);
                setSelectedModele(null);
                setMultiQueue([]);
                setMultiIndex(0);
                setRoute(previousRoute || "dashboard");
              }}
              onBatchNext={() => {
                if (multiIndex + 1 < multiQueue.length) {
                  setMultiIndex(multiIndex + 1);
                } else {
                  alert("[ok] Génération terminée !");
                  setMultiQueue([]);
                  setMultiIndex(0);
                  setRoute(previousRoute || "dashboard");
                }
              }}
            />
          )}
          {route === "multiRelationFilter" && (
            <MultiRelationFilter
              user={user}
              selectedModele={selectedModele}
              onGenerateBatch={(relations, modele) => {
                console.log("[pin] Batch reçu:", relations, modele);
                setMultiQueue(relations);
                setMultiIndex(0);
                setSelectedModele(modele);
                setPreviousRoute(route);
                setRoute("useModele");
              }}
            />
          )}
          {/* Relations dynamiques */}
          {relTypeKeys.includes(route) && (
            <RelationPage
              typeKey={route}
              user={user}
              onEdit={(item) => {
                setSelectedClient(item);
                setPreviousRoute(route);
              }}
            />
          )}
          {route === "editRelations" && (
            <EditRelations
              user={user}
              onBack={() => setRoute(previousRoute || "dashboard")}
              onSaved={() => {}}
            />
          )}
          {route === "editDossiers" && (
            <EditDossiers
              user={user}
              onBack={() => setRoute(previousRoute || "dashboard")}
              onSaved={() => {}}
            />
          )}
          {route === "placeholdersConfig" && (
            <PlaceholdersConfig
              user={user}
              modele={editingModele} // le modele actuellement edite
              onBack={() => setRoute(previousRoute || "uploadModele")}
              onSaved={(updatedModele) => {
                if (updatedModele) {
                  setEditingModele(updatedModele);
                  setSelectedModele((prev) =>
                    prev?.id === updatedModele.id
                      ? { ...prev, ...updatedModele }
                      : prev
                  );
                } else {
                  setEditingModele(editingModele);
                }
                setRoute(previousRoute || "uploadModele");
              }}
            />
          )}
          {/* ✅ Nouvelle page provisoire de publication marketplace */}
          {route === "marketplacePublish" && (
            <MarketplacePublish
              user={user}
              modele={editingModele}
              draft={editingDraft}
              onBack={() => {
                setEditingDraft(null);
                setRoute(previousRoute || "models");
              }}
              onDone={() => {
                setEditingDraft(null);
                setRoute("marketplaceManage");
              }}
            />
          )}
          {route === "marketplaceManage" && (
            <MarketplaceManage
              user={user}
              onBack={() => setRoute(previousRoute || "dashboard")}
              onCreate={() => {
                setEditingDraft(null);
                setPreviousRoute(route);
                setRoute("marketplacePublish");
              }}
              onEditDraft={(draft) => {
                setEditingDraft(draft);
                setPreviousRoute(route);
                setRoute("marketplacePublish");
              }}
              canModerate={false}
            />
          )}
          {/* Dossiers dynamiques */}
          {dosTypeKeys.includes(route) && (
            <DossierPage
              typeKey={route}
              user={user}
              onUse={(tpl) => {
                setPreviousRoute(route);
                setSelectedModele(tpl);
                setSelectedRecord(null);
                setRoute("useModele");
              }}
              onEdit={(tpl) => {
                setEditingModele(tpl);
                setRoute("uploadModele");
              }}
              onDelete={async (tpl) => {
                if (!user?.uid) return;
                const ok = confirm(
                  `Supprimer le modèle "${tpl.nom}" ?\nCette action supprimera aussi le fichier et sa configuration.`
                );
                if (!ok) return;
                try {
                  await deleteModele(user.uid, {
                    id: tpl.id,
                    storagePath: tpl.storagePath, // attendu par deleteModele
                    configPath: tpl.configPath, // idem (si existe)
                  });
                  // Nettoyage d’état local si nécessaire
                  if (selectedModele?.id === tpl.id) setSelectedModele(null);
                  if (editingModele?.id === tpl.id) setEditingModele(null);
                  alert("Modèle supprimé.");
                  // Pas besoin de rafraîchir : `listenModelesHybrid` mettra la liste à jour côté DossierPage.
                } catch (e) {
                  console.error(e);
                  alert("Échec de la suppression du modèle.");
                }
              }}
              onEditRecord={onEditRecord}
            />
          )}
            </>
          )}
        </main>
      </div>
      <button
        className="sidebar-toggle-fab"
        onClick={() => setSidebarOpen((v) => !v)}
        aria-label={sidebarOpen ? "Fermer le menu" : "Ouvrir le menu"}
      >
        <i className={`fas ${sidebarOpen ? "fa-times" : "fa-bars"}`} />
      </button>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/s/:token" element={<SharedFormPage />} />
      <Route path="*" element={<AppShell />} />
    </Routes>
  );
}
